// src/components/BoardTheme/Toolbar.js

import React from 'react';
import { Tooltip } from 'react-tooltip'; // Import Tooltip
import 'react-tooltip/dist/react-tooltip.css'; // Import the CSS for styling

const Toolbar = () => {
    const draggableItems = [
        { type: 'value', label: 'Value' },
        { type: 'barGraph', label: 'Bar Graph' },
        { type: 'line', label: 'Line' },
        { type: 'text', label: 'Text' },
        { type: 'time', label: 'Time' },
        { type: 'imageCustom', label: 'Image' },
        { type: 'imageIndicator', label: 'Image Indicator' },
        { type: 'recIndicator', label: 'Rec Indicator' },
        { type: 'specialIndicator', label: 'Special Indicator' },
        { type: 'speedLimiterIndicator', label: 'Speed Limiter Indicator' },
        { type: 'navMap', label: 'Navigation Map' },
        { type: 'navCompass', label: 'Navigation Compass' },
        { type: 'navInstruction', label: 'Navigation Instructions' },
        { type: 'navDirection', label: 'Navigation Direction' },
        
    ];

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap', // Enable wrapping
                paddingBottom: '10px',
            }}
        >
            {draggableItems.map((item) => (
                <div
                    key={item.type}
                    draggable
                    onDragStart={(e) => {
                        e.dataTransfer.setData('text/plain', item.type);
                        e.dataTransfer.effectAllowed = 'copyMove';
                    }}
                    style={{
                        margin: '3px',
                        padding: '2px',
                        color: '#1976d2',
                        fontWeight: 'bold',
                        cursor: 'grab',
                        textAlign: 'center',
                        borderRadius: '4px',
                        flex: '1 0 150px', // Allows items to grow and set base width
                        boxSizing: 'border-box', // Includes padding and border in width
                        minWidth: '120px', // Prevent items from becoming too small
                        transition: 'background-color 0.3s, transform 0.3s',
                        border: '1px solid #1976d2',
                    }}
                    data-tooltip-id="toolbar-tooltip" // Assign a tooltip ID
                    data-tooltip-content="Drag and drop onto the canvas" // Tooltip content
                >
                    {item.label}
                </div>
            ))}
            <Tooltip id="toolbar-tooltip" place="top" /> {/* Initialize the Tooltip */}
        </div>
    );
};

export default Toolbar;
